import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Topbar from "@/components/Topbar";
import Gate from "@/components/Gate";
import Calculator from "@/components/Calculator";
import Admin from "@/components/Admin";
import Quiz from "@/components/Quiz";
import MoneyBeliefAudit from "@/components/MoneyBeliefAudit";
import BridgeToBecoming, { BridgeVerify } from "@/components/BridgeToBecoming";
import useRouteMeta from "@/lib/useRouteMeta";

function Home() {
  const [lead, setLead] = useState(null);
  useRouteMeta("calculator");

  useEffect(() => {
    try {
      const stored = localStorage.getItem("fl_lead");
      if (stored) {
        const l = JSON.parse(stored);
        if (l && l.email) setLead(l);
      }
    } catch (e) { /* ignore */ }
  }, []);

  return (
    <div className="fl-app">
      <Topbar />
      {lead ? <Calculator lead={lead} /> : <Gate onUnlock={setLead} />}
    </div>
  );
}

function AdminPage() {
  return (
    <div className="fl-app">
      <Topbar />
      <Admin />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/quiz" element={<Quiz />} />
        <Route path="/audit" element={<MoneyBeliefAudit />} />
        <Route path="/bridge" element={<BridgeToBecoming />} />
        <Route path="/bridge/verify" element={<BridgeVerify />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
